import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private dialog = inject(MatDialog);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        /* 0 for xhr redirect(302) */
        if (error.status === 401 || error.status === 0) {
          this.dialog.open(LoginDialogComponent);
        }
        return throwError(() => error);
      })
    );
  }
}
